<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit.stop.prevent="guardar">
      <div>
        <b-row class="ml-1">
          <p style="color: var(--color-icono); font-weight: 600">Datos generales del vale</p>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group align="left">
              <label>Nombre del vale
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-form-input
                    class="redondeo"
                    id="idNombreVale"
                    placeholder="Ingresa el nombre del vale"
                    :state="validateState('nombre')"
                    v-model="$v.objGuardar.nombre.$model"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form>
              <b-form-group align="left">
                <label>Monto del vale
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input id="monto"
                                name="monto"
                                placeholder="Ingresa el monto"
                                type="number"
                                v-model="$v.objGuardar.saldo.$model"
                                :state="validateState('saldo')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group align="left">
              <label>Descripción del vale
                <validacion/>
              </label>

              <b-form-textarea
                  style="resize:both"
                  placeholder="Ingresa la descripción del vale"
                  v-model="$v.objGuardar.descripcion.$model"
                  rows="3"
                  max-rows="6"
                  :state="validateState('descripcion')"
              ></b-form-textarea>


            </b-form-group>

          </b-col>



          <b-col>
            <b-row>
              <b-col class="text-left"><label>Plan asociado <validacion/></label></b-col>
              <b-col class="text-right">
                <b-button
                    id="popover-boton-info"
                    style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                    variant="light"
                    class="rounded-circle mb-1 paddingbotones"
                >
                  <em class="i_info_svg sm"></em>
                </b-button>
                <b-popover target="popover-boton-info" triggers="focus" placement="topright">
                  <table aria-hidden="true">
                    <tbody>
                    <tr>
                      <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="2" style="color: #DF5B31"></b-icon></td>
                      <td><p class="mt-2 mb-2">Plan ya cuenta con un vale</p></td>
                    </tr>
                    <tr>
                      <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="2" style="color: #333333"></b-icon></td>
                      <td><p class="mt-2 mb-2">Pan sin vale</p></td>
                    </tr>
                    </tbody>
                  </table>
                </b-popover>
              </b-col>
            </b-row>

            <v-select
                @search="cargarCatalogo"
                @input="existePlanConfigurado($event)"
                style="width: 100%"
                label="nombre"
                :reduce="(val) => val.idPlan"
                placeholder="Selecciona un plan"
                :options="opcionesPlanAsociado"
                v-model="$v.objGuardar.idPlan.$model"
            >
              <template #option="{ nombre, cuentaConVale }">

                <li v-if="cuentaConVale" style="color: #DF5B31">{{ nombre }}</li>
                <li v-else>{{ nombre }}</li>

              </template>
              <span slot="no-options">No hay planes disponibles</span>
            </v-select>
            <p style="font-size: 0.60em; margin-top: 5px">Nota: Este vale se asignará a todos los pacientes existentes que cuentan con el plan asociado y las altas subsecuentes se asignarán automáticamente.</p>

          </b-col>

        </b-row>

      </div>
      <div class="text-center">
        <b-button
            class="mt-3 botonesAzulFuerte"
            variant="primary"
            style="margin:10px"
            @click="$refs.submitGuardar.click()">Guardar
        </b-button>

        <b-button
            class="mt-3 botonesGrisFuerte"
            style="margin:10px"
            @click="() => {$emit('cancelar')}">Cancelar
        </b-button>


      </div>
      <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
    </b-form>

  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {
  required
} from "vuelidate/lib/validators";

export default {
  name: "altaVales",

  props: {
    mostrarGuardar: Boolean,
    valeOriginal: Object
  },

  mixins: [validationMixin],

  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,

      objGuardar: {
        idVale: null,
        nombre: null,
        saldo: null,
        descripcion: null,
        idPlan: null,
        plan: null
      },

      opcionesPlanAsociado:[],
      planConfiguracion: {},
      idPlanAnterior: null,
      seleccionoPlan: false,

    };
  },
  validations() {
    return {
      objGuardar: {
        nombre: {required},
        saldo: {required},
        descripcion: {required},
        idPlan: {required}
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.cargarCatalogo();
    this.$nextTick(() => {
      this.$v.$reset()
    });
    if (!this.mostrarGuardar) {
      this.objGuardar = JSON.parse(JSON.stringify(this.valeOriginal));
      this.idPlanAnterior = this.objGuardar.idPlan
      this.cargarCatalogo(this.objGuardar.plan);
    }
  },
  methods:{
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },

    cargarCatalogo(search) {
      if ((search === undefined || search === '') && this.objGuardar.idPlan === null && !this.seleccionoPlan) {
        return;
      }

      if ((search === undefined || search === '') && this.objGuardar.idPlan !== null && !this.seleccionoPlan) {
        this.objGuardar.idPlan = null;
        return;
      } else if (this.seleccionoPlan) {
        this.seleccionoPlan = false;
        return;
      }

      this.opcionesPlanAsociado = [];
      const param = { nombrePlan: search}
      this.$http.post(this.$api + "vale/obtenerPlanesPorNombre", param).then(response => {
        if (response.data.data) {
              this.opcionesPlanAsociado = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }

      let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 18px; color: var(--color-gris)">Se creará el vale con los siguientes criterios, ¿desea continuar?</span></br></br>'
      let text = '<span style="font-size: 14px" >Tenga en cuenta los siguientes puntos:<br>' +
          '<li style="list-style: disc !important">La duración del vale personal es hasta la vigencia configurada en el plan.</li>' +
          '<li style="list-style: disc !important">A los pacientes existentes del plan se les creara un vale. </li>' +
          '<li style="list-style: disc !important">Este vale solo podrá ser usado para los tx del plan. </li>' +
          '<li style="list-style: disc !important">El descuento equivale al tope de utilización.</li> ' +
          '</span>'

      if (this.planConfiguracion.existeValePlan) {
        tituloAlerta =  '<span class="mt-4" style="font-weight:600; font-size: 18px; color: var(--color-gris)">El plan seleccionado ya tiene un vale configurado</span><br>'
        text = '<span style="font-size: 14px"> El plan seleccionado ya tiene asignado el vale “'+ this.planConfiguracion.nombre +'” con el id “'+ this.planConfiguracion.idVale +'”. Desactiva ese vale para asignar otro.</span>'
        this.$swal.fire({
          icon: 'error',
          html : tituloAlerta + text,
          showCloseButton: false,
          confirmButtonText: 'Enterado',
          confirmButtonColor: '#595959',
          customClass: {
            confirmButton: 'rounded-pill',
          },
        })
        return;
      }


      this.$swal.fire({
        width: '700px',
        icon: 'warning',
        html: tituloAlerta + text,
        showCloseButton: false,
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        confirmButtonColor: '#eeba6d',
        cancelButtonText: 'No, cancelar',
        cancelButtonColor: '#595959',
        customClass: {
          confirmButton: 'rounded-pill',
          cancelButton: 'rounded-pill'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.$http
              .post(this.$api + "vale/guardar", this.objGuardar)
              .then((response) => {
                if (response.status === 200) {
                  if (response.data.data.existeValePlan){
                    tituloAlerta =  '<span class="mt-4" style="font-weight:600; font-size: 18px; color: var(--color-gris)">El plan seleccionado ya tiene un vale configurado</span><br>'
                    text = '<span style="font-size: 14px"> El plan seleccionado ya tiene asignado el vale “'+ response.data.data.nombre +'” con el id “'+ response.data.data.idVale +'”. Desactiva ese vale para asignar otro.</span>'
                    this.$swal.fire({
                      icon: 'error',
                      html : tituloAlerta + text,
                      showCloseButton: false,
                      confirmButtonText: 'Enterado',
                      confirmButtonColor: '#595959',
                      customClass: {
                        confirmButton: 'rounded-pill',
                      },
                    })
                    return;
                  }

                  tituloAlerta = `<span class="mt-4" style="font-weight:600; font-size: 18px; color: var(--color-gris)"> ${this.mostrarGuardar ? 'El vale se creó con exito':'El vale se modifico con exito'} </span></br></br>`
                  this.$swal.fire({
                    icon: 'success',
                    html: tituloAlerta,
                    showCloseButton: false,
                    confirmButtonText: 'cerrar',
                    confirmButtonColor: '#595959',
                    customClass: {
                      confirmButton: 'rounded-pill',
                    },
                  })

                  this.$emit("actualizar", this.objGuardar);

                  this.$nextTick(() => {
                    this.$v.$reset()
                  });
                }
              }).catch((error)=>{
            console.error(error);
            this.$swal.fire({
              position: "center",
              icon: "error",
              title: "Ocurrio un error al registrar el vale",
              showConfirmButton: false,
              timer: 3500,
            });
          }).finally(() => {
            this.loading = false;
          });
        }
      })
    },

    existePlanConfigurado(valor) {
      this.seleccionoPlan = true;
      this.planConfiguracion = {}
      if (valor === null) {
        return;
      } else if (valor === this.idPlanAnterior) {
        return;
      }
      const params = {
        idPlan: valor
      }

      this.$http.post(this.$api + "vale/existePlanConfig", params  ).then(response => {
        if (response.data.data) {
          this.planConfiguracion = response.data.data;
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  },

}
</script>

<style scoped>
.swal-button{
  font-size: 12px !important;
}
.paddingbotones {
  padding-top: 5px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
}
</style>